module.exports = __webpack_public_path__ + "img/room-status.df2717a3.svg";